/**
 * Created by Administrator on 2017/5/18.
 */
import Vue from 'vue';
import globalConfig from 'common/js/GlobalConfig';
import corsAjax from 'common/js/cors-ajax';
import layer from 'common/lib/layer/layer';
import VueCookie from 'vue-cookie'

function doFunction(callback){
  if(typeof callback === "function"){
    callback();
  }
}
var isSync = false;
var callbackList = []
var Vpermission = ''
function doAfterSyncLogin (vue, callback, syncLogin, loginType,permission) {
  if(permission){
    Vpermission = permission
  }
  loginType = loginType||globalConfig.defaultLoginType;
  if(syncLogin){ //需要请求接口
    localStorage.clear();
    vue.loginUser = {};
  }
  var token = VueCookie.get("token")
  if(!token){//没有cookie
    var url = window.location.href;
    var domain = globalConfig.domain.forensicsWebOp;
    if (!url.startsWith(domain+"/login.html")
        && !url.startsWith(domain+"/resetPwd.html")
        && !url.startsWith(domain+"/register.html")) {//需登录
      toAccountAuth();
    } else {
      //login
    }
  } else {//校验cookie
    if(isSync){
      var cnt = 0;
      var timer = window.setInterval(function(){
        var hasToken = localStorage.getItem(globalConfig.STORAGE_TOKEN_NAME);
        if (hasToken) {//页面已经登录
          window.clearInterval(timer);
          Vpermission&&checkPermissions(vue,Vpermission)
          vue.loginUser = JSON.parse(localStorage.getItem(globalConfig.STORAGE_USER));
          if(vue.parentUserInfo&&Object.getOwnPropertyNames(vue.parentUserInfo).length>1){
            doFunction(callback);
            dealCallbackList(vue)
          }else{
            callbackList.push(callback)
          }
        }else if(++cnt >= 50) {
          window.clearInterval(timer);
          dealCallbackList(vue)
        }
      }, 100);
      return ;
    }
    isSync = true;
    doAfterTokenCheck(vue, callback, loginType, token);
  }
}

function dealCallbackList(vue){
  while (callbackList.length){
    try {
      doFunction(callbackList.shift())
    }catch (e) {
      console.log(e)
    }
    if(!callbackList.length){
    }
  }
}
function doAfterApiSyncLogin(vue, callback, loginType){
  corsAjax({
    url: globalConfig.domain.accountWeb + "/login/syncLogin?r=" + Math.random(),
    method: "post",
    withCredentials: true,
    success: function (response) {
      isSync = false;
      console.log("user form syncLogin:"+response.success);
      if (response.success) {//account已登录
        localStorage.setItem(globalConfig.STORAGE_TOKEN_NAME, response.data.token);
        localStorage.setItem(globalConfig.STORAGE_USER, JSON.stringify(response.data.loginUser));
        vue.loginUser = response.data.loginUser;
        syncChildren(vue, vue.loginUser);
        doFunction(callback);
      } else {//account没有登录
        localStorage.clear();
        vue.loginUser = {};

        if(loginType == 1){//跳转到account登录页面
          window.location.href = globalConfig.domain.forensicsWebOp + "/login.html?returnURL=" + encodeURIComponent(location.href);
        } else if(loginType==2){//弹出登录框登录
          layer.open({
            type: 2,
            title: false,
            icon:2,
            closeBtn: 0,
            area: ['400px','480px'],
            fixed: false, //不固定
            content: [globalConfig.domain.accountWeb
            +'/plogin/loginPage?corsUrl='
            +encodeURIComponent(globalConfig.domain.athenaWebUms+"/login-cors.html"),'no'],
            success: function () {
              $(".layui-layer-iframe,.layui-layer-content").css("border-radius", "10px");
            }
          });
        } else {//此页面可以不登录访问
        }
      }
    }
  });
}

function toAccountAuth() {
  var ap = encodeURIComponent(location.href);
  var cp = encodeURIComponent(globalConfig.domain.forensicsWebOp+"/author.html");
  var lp = encodeURIComponent(globalConfig.domain.forensicsWebOp+"/login.html");
  window.location.href = globalConfig.domain.accountWeb + "/login/authorization?ap=" + ap+"&cp="+cp+"&lp="+lp;
}
function doAfterTokenCheck(vue, callback, loginType, token){
  corsAjax({
    url: globalConfig.domain.accountWeb + "/sso/tkcheck?t="+token+"&r=" + Math.random(),
    method: "post",
    withCredentials: true,
    success: function (response) {
      isSync = false;
      console.log("user form syncLogin:"+response.success);
      if (response.success) {//account已登录
        localStorage.setItem(globalConfig.STORAGE_TOKEN_NAME, response.data.token);
        localStorage.setItem(globalConfig.STORAGE_USER, JSON.stringify(response.data.loginUser));
        vue.loginUser = response.data.loginUser;
        syncChildren(vue, vue.loginUser,'loginUser');
        getParentUserInfo(vue,callback);
      } else {//account没有登录
        localStorage.clear();
        VueCookie.delete(globalConfig.COOKIE_TOKEN_NAME)
        vue.loginUser = {};
        if(loginType == 1){//跳转到account登录页面
          toAccountAuth();
        } else if(loginType==2){//弹出登录框登录
          layer.open({
            type: 2,
            title: false,
            icon:2,
            closeBtn: 0,
            area: ['400px','480px'],
            fixed: false, //不固定
            content: [globalConfig.domain.accountWeb
            +'/plogin/loginPage?corsUrl='
            +encodeURIComponent(globalConfig.domain.forensicsWebOp+"/login-cors.html"),'no'],
            success: function () {
              $(".layui-layer-iframe,.layui-layer-content").css("border-radius", "10px");
            }
          });
        } else {//此页面可以不登录访问
        }
      }
    }
  });
}
function getParentUserInfo(vue,callback) {
  corsAjax({
    url: globalConfig.domain.forensicsBackstage + "/account/user/profile",
    method: "get",
    withCredentials: true,
    success: function (response) {
      if (response.success) {
        vue.parentUserInfo = response.data||{};
        syncChildren(vue,vue.parentUserInfo,'parentUserInfo')
      }
      Vpermission&&checkPermissions(vue,Vpermission)
      dealCallbackList(vue)
      doFunction(callback);
    }
  });
}
function syncChildren(vue, loginUser,key){
  let arr = vue.$children;
  if(arr.length<1){
    return ;
  } else{
    for(var idx=0;idx<arr.length;idx++){
      arr[idx][key] = loginUser;
      syncChildren(arr[idx], loginUser,key);
    }
  }
}

function checkPermissions(vue,permission){
  let status = false
  if(vue.parentUserInfo){
    if(vue.parentUserInfo.operatorType !== 3) {
      return true
    }
    if(vue.parentUserInfo.permissionCodes){
      status = vue.parentUserInfo.permissionCodes.indexOf(permission) > -1
    }
    if(!status){
      Vpermission = ''
      location.href = '/withoutPower.html'
    }
  }
}

function updateLocalUser (vue, loginUser) {
  if(loginUser && typeof loginUser === "object"){
    localStorage.setItem(globalConfig.STORAGE_USER, JSON.stringify(loginUser));
  } else {
    doAfterSyncLogin(vue);
  }
}

window.layerIframeAuto = function(wn, height){
  var index = layer.getFrameIndex(wn);
  var layuiLayer = $("#layui-layer"+index);
  var layuiLayerIframe = layuiLayer.find("iframe");
  layuiLayer.css("height", height);
  layuiLayerIframe.css("height", height);
};
window.flushAfterLogin = function(){
  window.location.href = window.location.href;
}

Vue.prototype.doAfterSyncLogin = doAfterSyncLogin;
Vue.prototype.updateLocalUser = updateLocalUser;



// WEBPACK FOOTER //
// ./src/common/js/sync-login.js